import React from 'react';
import PropTypes from 'prop-types';
import Joi from 'joi';

import ErrorTemplate from 'pageTemplates/error';

const isStatusCode = (value) => value && value >= 200 && value < 600;

const Error = ({ statusCode }) => <ErrorTemplate status={statusCode} />;

Error.getInitialProps = ({ res, err }) => {
	let statusCode = [err.statusCode, err.status].find(isStatusCode);

	if (!statusCode && Joi.isError(err)) {
		statusCode = 400;
	}

	if (!statusCode) {
		statusCode = res.statusCode || 500;
	}

	if (res.statusCode !== statusCode) {
		res.status(statusCode);
	}

	return { statusCode };
};

Error.propTypes = {
	statusCode: PropTypes.number.isRequired
};

export default Error;
